module.exports = __webpack_public_path__ + "static/img/3.ba7e1815.svg";